export const errorCode = {
  NotAuthorized: 200020,
  AccessDenied: 200013,
  NetworkError: -8,
  CancelRequest: -1,
  LimitExceeded: 700015
};
